module.exports = __webpack_public_path__ + "img/icon_gongneng9.3c18e27d.svg";